import { render, staticRenderFns } from "./Termos.vue?vue&type=template&id=ecbc7c7a&scoped=true"
import script from "./Termos.vue?vue&type=script&lang=js"
export * from "./Termos.vue?vue&type=script&lang=js"
import style0 from "./Termos.vue?vue&type=style&index=0&id=ecbc7c7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecbc7c7a",
  null
  
)

export default component.exports